import { Box, Link, Typography } from "@mui/material"
import type { FC } from "react"
import { Link as RouterLink } from "react-router-dom"

type IdKind = "reservation" | "locker"

type Props = {
  kind: IdKind
  sstId?: string
  sl2Id?: string
}

const sstHrefFor = (kind: IdKind, id: string): string | null => {
  if (kind === "locker") return `/sa/sstv2/lockers/${encodeURIComponent(id)}`
  return null
}

const sl2HrefFor = (kind: IdKind, id: string): string | null => {
  if (kind === "reservation")
    return `/os/reservations/${encodeURIComponent(id)}`
  if (kind === "locker") return `/os/lockers/${encodeURIComponent(id)}`
  return null
}

const Row: FC<{ label: "sst" | "sl2"; id?: string; href: string | null }> = ({
  label,
  id,
  href,
}) => {
  const idText = id ? (
    href ? (
      <Link
        component={RouterLink}
        to={href}
        sx={{ fontFamily: "monospace", fontSize: 12 }}
      >
        {id}
      </Link>
    ) : (
      <Typography
        variant="caption"
        component="span"
        sx={{ fontFamily: "monospace", fontSize: 12 }}
      >
        {id}
      </Typography>
    )
  ) : (
    <Typography
      variant="caption"
      component="span"
      sx={{ fontFamily: "monospace", fontSize: 12, color: "text.disabled" }}
    >
      -
    </Typography>
  )

  return (
    <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75 }}>
      <Typography
        variant="caption"
        component="span"
        sx={{
          fontFamily: "monospace",
          fontSize: 11,
          color: "text.secondary",
          width: 28,
          flexShrink: 0,
        }}
      >
        {label}:
      </Typography>
      {idText}
    </Box>
  )
}

export const SstSl2IdPair: FC<Props> = ({ kind, sstId, sl2Id }) => {
  if (!sstId && !sl2Id) {
    return (
      <Typography variant="caption" color="text.secondary">
        -
      </Typography>
    )
  }
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
      <Row label="sst" id={sstId} href={sstId ? sstHrefFor(kind, sstId) : null} />
      <Row label="sl2" id={sl2Id} href={sl2Id ? sl2HrefFor(kind, sl2Id) : null} />
    </Box>
  )
}
